'use client';
import { setCookie } from '@/utils';
import { ChevronRight, Equal, LogOut, X } from 'lucide-react';
import Link from 'next/link';
import React from 'react';

export default function HamburgerMenu(): React.ReactNode {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSignout = () => {
    setCookie('token', '', 0);
    window.location.href = '/';
  };

  return (
    <div className='block sm:hidden'>
      <button
        onClick={toggleMenu}
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMenuOpen}
        className='flex items-center'
      >
        {isMenuOpen ? <X /> : <Equal />}
      </button>
      {isMenuOpen && (
        <div className='absolute top-[56px] left-0 z-50 flex h-[calc(100vh-56px)] w-full flex-col gap-1 bg-zinc-950 p-3 text-sm font-medium text-white'>
          <Link
            className='flex justify-between border-b border-zinc-900 px-2 py-3'
            href={`/organizer`}
          >
            <p>List Your Event</p>
            <ChevronRight />
          </Link>
          <Link
            className='flex justify-between border-b border-zinc-900 px-2 py-3'
            href={`/search`}
          >
            <p>Search Events</p>
            <ChevronRight />
          </Link>
          <Link
            className='flex justify-between border-b border-zinc-900 px-2 py-3'
            href={`/organizer`}
          >
            <p>Contact Us</p>
            <ChevronRight />
          </Link>
          <Link
            className='flex justify-between border-b border-zinc-900 px-2 py-3'
            href={`/organizer`}
          >
            <p>FAQs</p>
            <ChevronRight />
          </Link>
          <button
            onClick={handleSignout}
            className='flex justify-between border-b border-zinc-900 px-2 py-3'
          >
            <p>Logout</p>
            <LogOut />
          </button>
        </div>
      )}
    </div>
  );
}
